import {getImageSrc} from 'utils/paths';

export const IMAGE_TYPES = ['full', 'thumb'];

export const imageCache = {};

export function preloadWork(work, callback, cache=imageCache){
	if (work && work.type == 'image'){
		if (!cache){
			cache = {};
		}
		if (!cache[work.id]){
			cache[work.id] = {
				thumb: {},
				full: {}
			}
		}

		cache[work.id] = {};
		let c = cache[work.id];

		IMAGE_TYPES.forEach(t => {
			let img = new Image();
			img.onload = function(){
				if (typeof callback === 'function'){
					callback.call(this, t,  work);
				}
			}
			img.src = getImageSrc(work, t);	
			cache[work.id][t] = img;
		})
	}
	return cache;
}
